module.exports = __webpack_public_path__ + "static/media/bf645663.jpg";